import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { Button } from '../../../../components/Buttons';
import { Camera, Check, Image, IsClosed, IsOpen, Left, Plus, Times, View } from '../../../../components/Icon';
import { Loader } from '../../../../components/Loader';
import { Modal, ModalControls } from '../../../../components/Modal';
import { VehicleAvatar } from '../../../../components/VehicleAvatar';
import { selectWork, selectWorks } from '../../../Api/selectors';
import { VehicleHeader } from '../../../Vehicles/components/VehicleHeader';
import { performAction } from '../../actions';
import { REQUEST_KANBAN_BOARD_PERFORM_ACTION } from '../../constants';
import { PerformActionButton } from '../PerformActionButton';
import { BaseCellComp } from '../BaseCellComp';
import { CellButton, CellButtons } from '../CellButton';
import { Well } from '../../../../components/Well';
import { HBox, VBox } from '../../../../components/Box';
import { List, Row, Cell } from '../../../../components/List';
import { selectAllOptions, selectVehicle } from '../../../Vehicles/selectors';
import { Checkbox } from '../../../../components/Checkbox';
import { addVehicleOption, deleteVehicleProperty, removeVehicleOption, setVehicleProperty } from '../../../Vehicles/actions';
import { ButtonBar } from '../../../../components/ButtonBar';
import _ from 'lodash';
import { REQUEST_VEHICLE, REQUEST_VEHICLE_PROPERTY_UPDATE } from '../../../Vehicles/constants';
import { COLOR_PRIMARY_1, COLOR_SECONDARY_1 } from '../../../../vars';
import { FormField } from '../../../../components/FormFields';
import { Input } from '../../../../components/Input';
import { Dropdown } from '../../../../components/Dropdown';
import { addDocument, deleteDocument } from '../../../Documents/actions';
import { REQUEST_ADD_DOCUMENT, REQUEST_DELETE_DOCUMENT } from '../../../Users/constants';
import { CompanyLabelById } from '../../../Companies/components/CompanyLabelById';
import { TireData } from '../../../Vehicles/components/TireData';
import DatePicker from 'react-datepicker';
import dayjs from 'dayjs';
import { parseISO } from 'date-fns';
import { VehiclePropertyLoadable } from '../../../Vehicles/components/VehiclePropertyLoadable';
import { WithVehicle } from '../../../Vehicles/components/WithVehicle';
import { UserLabelById } from '../../../Users/components/UserLabelById';
import { VehiclePropertyEditableInput } from '../../../Vehicles/components/VehiclePropertyEditableInput';

import { Cell as ActionCell } from '../Cell';
import { resizeAndRotate } from '../../../../utils/image';
import { VehicleStatusLabel } from '../../../Vehicles/components/VehicleStatusLabel';
import { getDate } from '../../../Vehicles/helpers';
import { Label, getLabelColor } from '../../../Vehicles/components/VehicleCounterLabel';
import { formatLicensePlate } from '../../../../utils/string';
import { isMobileDevice } from '../../../../utils/checkDevice';

//change this for values of counters
const ranges = {
  MediumSeaGreen: [1, 3],
  DarkOrange: [4, 6],
  Crimson: [7, Infinity],
};
const Container = styled.div`
  .modal-inner {
  }

  .option {
    &.inactive {
      opacity: 0.5;
    }
  }

  .pane {
    border-top: 1px solid #eee;
    padding: 12px 0;
    border-bottom: 1px solid #eee;
    width: 100%;
    margin-bottom: 12px;
    border-bottom: none;

    .title {
      text-transform: uppercase;
    }
    h1 {
      font-size: 18px;
    }
  }

  .optionPhoto {
    position: fixed;
    background-color: black;

    .img {
      position: absolute;
      top: 90px;
      left: 10px;
      right: 10px;
      bottom: 10px;
      background-size: contain;
      background-position: center center;
    }
  }
  .options-list {
    .title {
      font-weight: 600;
      margin-top: 12px;
      font-size: 1.2rem;
      border-bottom: 1px solid #ddd;
      width: 100%;
      margin-bottom: 3px;
    }
  }
  .image-available {
    width: 32px;
    height: 32px;
    background-color: ${COLOR_SECONDARY_1};
    color: white;
    border-radius: 15px;
    text-align: center;
    margin-right: 3px;
    padding-top: 1px;

    .icon {
      margin: 0;
      padding: 0 0;
    }
  }

  .manco-list > div {
    margin: 12px 0;
  }

  .triple {
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin: 12px 0;

    .btn-check:checked + .btn {
      background-color: var(--color-new-secondary);
      border-color: var(--color-new-secondary);
      color: #fff; /* optioneel: tekst wit voor contrast */
    }
    .btn-check:not(:checked) + .btn {
      border-color: var(--color-new-primary);
      color: var(--color-new-primary);
    }

    transition: opacity 0.2s;
    .check {
      transition: opacity 0.2s;
      display: inline-block;
      width: 24px;
      height: 24px;
      border: 1px solid ${COLOR_PRIMARY_1};
      color: ${COLOR_PRIMARY_1};
      text-align: center;
      font-size: 21px;
      line-height: 20px;
    }

    &.triple-0 {
      .check {
      }
    }
    &.triple-1 {
      .check {
        border: 1px solid #3bb78e;
        color: #3bb78e;
      }
    }
    &.triple-2 {
      .check {
        border: 1px solid red;
        text-align: center;
        color: red;
      }
    }

    &.disabled {
      opacity: 0.4;
      .check {
        opacity: 0;
      }
    }
  }

  .tire_set {
    padding: 12px;
    background-color: #eee;

    > .box {
      max-width: 330px;
    }

    .half-width-cell {
      width: 50%;
      text-align: left;
    }
    .tire-depth-container {
      width: 100%;
      .button {
        width: 60px;
        margin: 1px;
        align-self: stretch;
      }
    }

    .vehicle-property-loadable {
      max-width: 300px;
      &.loading {
        opacity: 0.2;
      }
    }
  }
  .small_letters {
    font-size: 12px;
  }

  .attention-img {
    width: 100px;
    height: 100px;
    flex-shrink: 0;
    background-size: contain;
    border: 1px solid black;
    background-position: center center;
    .add {
      width: 100px;
      height: 100px;
    }
  }
`;

const STATE = {
  approve: false,
  options: false,
  manco: false,
  attention: false,
  regplate_code: '',
  date_last_maintenance: '',
  mileage_last_maintenance: '',
  date_timing_belt_change: '',
  mileage_timing_belt_change: '',
};

/* eslint-disable react/prefer-stateless-function */
class IDW_export_overviewComp extends BaseCellComp {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {
    const comments = this.vehicle?.properties
      ?.filter(p => p?.propertyName?.name?.startsWith('attention_comment_'))
      ?.reduce(
        (acc, prop) => ({
          ...acc,
          [prop?.propertyName?.name]: prop?.propertyValue?.value,
        }),
        {},
      );
    this.setState({ ...comments });
  }

  reset() {
    this.setState({ ...STATE });
  }

  static getDerivedStateFromProps(props, state) {
    ['date_last_maintenance', 'mileage_last_maintenance', 'mileage_timing_belt_change'].map(name => {
      let val = props.cell?.vehicle[name];
      if (val) {
        if (val.updatedAt != state[name + '_updatedAt']) {
          state[name + '_updatedAt'] = val.updatedAt;
          state[name] = val.propertyValue.value;
        }
      } else {
      }
    });
    return state;
  }

  confirm() {
    //apprive BVI ...
    this.props.confirm(this.vehicle.id, this.state.regplate_code);
  }

  propertyValue(name) {
    return this.vehicle[name];
  }

  get vehicle() {
    return this.props.vehicle || this.props.cell.vehicle;
  }

  capture(name, callback) {
    //remove existing image upload
    document.getElementById('image-upload')?.remove();

    let input = document.createElement('input');
    input.type = 'file';
    input.name = 'image';
    input.id = 'image-upload';
    input.accept = 'image/*';
    // input.setAttribute('capture', 'camera');

    if (isMobileDevice()) {
      input.setAttribute('capture', 'environment');
    }

    document.body.appendChild(input);

    input.click();

    input.addEventListener(
      'change',
      this.callback(evt => {
        resizeAndRotate(evt.target.files[0]).then(file => {
          this.props.imageUpload(
            {
              name,
              type: 'photo_interior_' + name,
              originalFilename: 'originalFilename',
              file,
            },
            'upload_' + name,
          );

          callback?.();

          try {
            evt.target.removeEventListener(evt.target, this._evtListener);
            evt.target.remove();
          } catch (e) {}
        });
      }),
    );
  }

  toggleOption(id, state) {
    this._lastOption = id;

    //todo: busy_ ... is depricated
    this.setState(
      { [`busy_${id}`]: true },
      this.props.toggleOption(id, state, result => {
        this.setState({ [`busy_${id}`]: false });
      }),
    );
  }

  renderPane(name, title, content) {
    return (
      <div className="pane">
        <HBox vCenter className="title" onClick={this.setStateFn({ [name]: true })}>
          {title}
          <div>
            <IsOpen />
          </div>
        </HBox>
        {content}
      </div>
    );
  }

  renderFormField(name, type) {
    let ISO;
    if (type == 'date') {
      let date = this.vehicle[name];
      try {
        ISO = date ? parseISO(dayjs(date, 'DD-MM-YYYY').format('YYYY-MM-DD')) : null;
        if (ISO == 'Invalid Date') ISO = null;
      } catch (error) {
        debugger;
      }
    }
    return (
      <FormField label={this.lbl('vehicle.property.' + name)} key={name}>
        <VehiclePropertyLoadable name={name}>
          {type == 'date' ? (
            <DatePicker
              dateFormat="dd-MM-yyyy"
              selected={this.vehicle[name] ? ISO : ''}
              onChange={val => {
                val = dayjs(val).format('DD-MM-YYYY');
                this.props.setProperty(name, val);
              }}
            />
          ) : (
            <Input
              type={type}
              value={this.state[name]}
              onChange={this.onInputChange.bind(this)}
              name={name}
              key={name}
              onBlur={() => {
                this.props.setProperty(name, this.state[name]);
              }}
            />
          )}
        </VehiclePropertyLoadable>
      </FormField>
    );
  }

  renderOption(value, index) {
    if (value.title)
      return (
        <div className="title" key={index}>
          {this.lbl(`vehicle.options.${value.title}`)}
        </div>
      );

    let option = this.props.allOptions?.find(o => o.name.toLowerCase() == value.toLowerCase());

    // if (!option) debugger;

    let vehicleHasOption = this.vehicle.options?.find(o => o.id == option?.id);

    let checked_name = `checked_${value}`;

    let checked = this.state[checked_name] || vehicleHasOption;
    let photo = this.vehicle.documents?.find(document => document.type == 'photo_interior_' + value);

    let name = `vehicle-option-${option?.id}`;

    return (
      <HBox vCenter key={index} className={`option ${!option ? 'inactive' : ''} option-${option?.id}`}>
        <div>
          <VehiclePropertyLoadable name={name}>
            <Checkbox checked={checked} onChange={option ? () => this.toggleOption(option.id, !checked) : null}>
              {value}
            </Checkbox>
          </VehiclePropertyLoadable>
        </div>
        <VehiclePropertyLoadable name={`upload_${value}`}>
          {photo ? (
            <div
              className="pointer image-available"
              onClick={() => {
                let container = document.getElementsByClassName('modal-inner')[0];
                let renderOptionPhotoDims = container.getBoundingClientRect();
                this.setState({
                  renderOptionPhoto: photo.id,
                  renderOptionPhotoDims,
                });
              }}
            >
              <Camera />
            </div>
          ) : (
            <div onClick={this.setStateFn({ optionPhoto: option?.id })} className="pointer">
              <Camera
                onClick={() =>
                  this.capture(
                    value,
                    this.callback(() => this.props.toggleOption(option.id, true)),
                  )
                }
              />
            </div>
          )}
        </VehiclePropertyLoadable>
      </HBox>
    );
  }

  handlePhotoDelete = documentId => {
    if (confirm()) {
      const group = this.vehicle.documents?.find(d => d.id === documentId)?.type;
      if (this.vehicle.documents?.filter(d => d?.type === group)?.length === 1) {
        const index = group?.slice(25);
        this.setState({ [`attention_comment_${index}`]: '' });
        this.props.deleteProperty(`attention_comment_${index}`);
        this.props.deleteProperty(`attention_repaired_${index}`);
        this.props.deleteProperty(`attention_displayed_${index}`);
      }
      this.props.deleteDocument(documentId, this.setStateFn({ renderOptionPhoto: null }));
    }
  };

  renderApprove() {
    if (!this.state.approve) return null;

    return (
      <Modal
        onClose={this.reset.bind(this)}
        title={
          <>
            {this.props.fullFetch ? (
              <>
                <Loader small />
                &nbsp;
              </>
            ) : null}
            {this.props.action.label}
          </>
        }
      >
        <WithVehicle loader vehicle_id={this.vehicle.id}>
          {this.renderModalBody()}
        </WithVehicle>
      </Modal>
    );
  }

  renderTripleCheck(name) {
    let val = this.propertyValue(name);
    let state = val == 1 ? 1 : val == 2 ? 2 : 0;

    return (
      <HBox vCenter key={name}>
        <div
          className={`triple triple-${state} ${this.props.work ? 'disabled' : ''}`}
          // onClick={() => this.props.setProperty(name, state == 0 ? 1 : state == 1 ? 2 : 0)}
        >
          <div className="label">{this.lbl(`vehicle.property.${name}`)}</div>
          <VehiclePropertyLoadable name={name}>
            <div className="btn-group" role="group" aria-label="Basic radio toggle button group">
              <input
                type="radio"
                className="btn-check"
                name={`btnradio-${name}`} // uniek per veld
                id={`btnradio1-${name}`}
                autoComplete="off"
                checked={state == 0}
                onChange={() => this.props.setProperty(name, 0)}
              />
              <label className="btn btn-outline-primary" htmlFor={`btnradio1-${name}`}>
                Todo
              </label>

              <input
                type="radio"
                className="btn-check"
                name={`btnradio-${name}`}
                id={`btnradio2-${name}`}
                autoComplete="off"
                checked={state == 1}
                onChange={() => this.props.setProperty(name, 1)}
              />
              <label className="btn btn-outline-primary" htmlFor={`btnradio2-${name}`}>
                Gereed
              </label>

              <input
                type="radio"
                className="btn-check"
                name={`btnradio-${name}`}
                id={`btnradio3-${name}`}
                autoComplete="off"
                checked={state == 2}
                onChange={() => this.props.setProperty(name, 2)}
              />
              <label className="btn btn-outline-primary" htmlFor={`btnradio3-${name}`}>
                Manco
              </label>
            </div>
          </VehiclePropertyLoadable>
        </div>
      </HBox>
    );
  }

 
  renderDoubleCheck(name) {
    let val = this.propertyValue(name);
    let state = val == 1 ? 1 : 0;

    return (
      <HBox vCenter key={name}>
        <div
          className={`triple triple-${state} ${this.props.work ? 'disabled' : ''}`}
          onClick={() => this.props.setProperty(name, state == 0 ? 1 : 0)}
        >
          <VehiclePropertyLoadable name={name}>
            <div className="check">{state == 0 ? '-' : '+'}</div>
          </VehiclePropertyLoadable>
          <div className="label">{this.lbl(`vehicle.property.${name}`)}</div>
        </div>
      </HBox>
    );
  }

  addAttentionImage(index, isNewGroup = false) {
    this.capture('attention_' + index);
    if (isNewGroup) {
      this.props.setProperty(`attention_repaired_${index}`, 0);
      this.props.setProperty(`attention_displayed_${index}`, 1);
      this.props.setProperty(`attention_comment_${index}`, '');
    }
  }

  renderAttentionPhoto(document) {
    return (
      <div key={`attention-${document.id}`}>
        <div
          className="attention-img"
          onClick={() => {
            let container = window.document.getElementsByClassName('modal-inner')[0];
            let renderOptionPhotoDims = container.getBoundingClientRect();
            this.setState({
              renderOptionPhoto: document.id,
              renderOptionPhotoDims,
            });
          }}
          style={{ backgroundImage: `url('${document.url}')` }}
        ></div>
      </div>
    );
  }

  renderModalBody() {
    return (
      <>
        <VBox key="body">
          {this.renderPane(
            'Voertuiggegevens',
            <h1>{this.lbl('interior.inspection.vehicledata')}</h1>,
            <VBox className="manco-list" key="manco">
              <Row>
                <div className="half-width-cell">
                  <Cell>{this.lbl(`vehicle.property.debitor_company`)}</Cell>
                </div>
                <div className="half-width-cell">
                  <Cell>
                    &nbsp;
                    <CompanyLabelById company_id={this.vehicle?.invoice_outgoing_company_id} />
                  </Cell>
                </div>
              </Row>

              <Row>
                <div className="half-width-cell">
                  <Cell>{this.lbl(`vehicle.property.regplate`)}</Cell>
                </div>
                <div className="half-width-cell">
                  <Cell>{formatLicensePlate(this.vehicle?.regplate)}</Cell>
                </div>
              </Row>
              {this.vehicle.task_apk_done === '1' ? null : (
                <Row>
                  <div className="half-width-cell">
                    <Cell>{this.lbl(`vehicle.property.date_apk_expiry`)}</Cell>
                  </div>
                  <div className="half-width-cell">
                    {' '}
                    <Cell>{this.vehicle?.date_apk_expiry}</Cell>
                  </div>
                </Row>
              )}
              {this.vehicle.task_apk_done === '1' ? (
                <Row>
                  <div className="half-width-cell">
                    <Cell>{this.lbl(`vehicle.property.task_apk_done_date`)}</Cell>
                  </div>
                  <div className="half-width-cell">
                    <Cell>{getDate(this.vehicle?.task_apk_done_date)}</Cell>
                  </div>
                </Row>
              ) : null}
              <Row>
                <div className="half-width-cell">
                  <Cell>{this.lbl(`vehicle.property.paid_status`)}</Cell>
                </div>
                <div className="half-width-cell">
                  <Cell>
                    <VehicleStatusLabel color={this.vehicle?.outgoing_invoice_payment_status ? '#15AC79' : 'red'}>
                      {this.vehicle?.outgoing_invoice_payment_status ? 'betaald' : 'niet betaald'}
                    </VehicleStatusLabel>
                  </Cell>
                </div>
              </Row>
              <Row>
                <div className="half-width-cell">
                  <Cell>{this.lbl(`vehicle.property.outgoing_bpm_refund_deposit`)}</Cell>
                </div>
                <div className="half-width-cell">
                  {' '}
                  <Cell>
                    {this.vehicle?.outgoing_bpm_refund_deposit === '1'
                      ? this.lbl(`vehicle.property.yes`)
                      : this.lbl(`vehicle.property.no`)}
                  </Cell>
                </div>
              </Row>
              <Row>
                <div className="half-width-cell">
                  {' '}
                  <Cell>{this.lbl(`vehicle.property.BPM_refund_via_indewal`)}</Cell>
                </div>
                <div className="half-width-cell">
                  <Cell>
                    {this.vehicle?.BPM_refund_via_indewal === '1'
                      ? this.lbl(`vehicle.property.yes`)
                      : this.lbl(`vehicle.property.no`)}
                  </Cell>
                </div>
              </Row>

              {this.vehicle.new_from_factory === '1' ? (
                <Row>
                  <div className="half-width-cell">
                    <Cell>{this.lbl(`vehicle.property.nieuwverklaring`)}</Cell>
                  </div>
                  <div className="half-width-cell">
                    <Cell>
                      {this.vehicle?.new_from_factory === '1'
                        ? this.lbl(`vehicle.property.no_zullassung_neccesary`)
                        : this.lbl(`vehicle.property.no_zullassung_neccesary`)}
                    </Cell>
                  </div>
                </Row>
              ) : (
                <Row>
                  <div className="half-width-cell">
                    {' '}
                    <Cell>{this.lbl(`vehicle.property.apply_zulassung`)}</Cell>
                  </div>
                  <div className="half-width-cell">
                    <Cell>
                      {this.vehicle?.zulassung_aanvragen === '1'
                        ? this.lbl(`vehicle.property.yes`)
                        : this.lbl(`vehicle.property.no`)}
                    </Cell>
                  </div>
                </Row>
              )}

              {this.vehicle.task_recall_done === '1' ? (
                <Row>
                  <div className="half-width-cell">
                    <Cell>{this.lbl(`vehicle.property.task_recall_done_date`)}</Cell>
                  </div>
                  <div className="half-width-cell">
                    <Cell>{getDate(this.vehicle?.task_recall_done_date)}</Cell>
                  </div>
                </Row>
              ) : null}
            </VBox>,
          )}

          {this.renderPane(
            'Proces',
            <h1>{this.lbl('interior.inspection.export_taken')}</h1>,
            <VBox className="manco-list" key="manco">
              <Row>
                <Cell>
                  {['apk_check'].map(name => this.renderDoubleCheck(name))}
                  {!this.vehicle?.task_apk_done
                    ? ['task_apk'].map(name => this.renderDoubleCheck(name))
                    : this.lbl('interior.export.apk-done')}

                  <p></p>
                  {['recall_check'].map(name => this.renderDoubleCheck(name))}

                  {!this.vehicle?.task_recall_done
                    ? ['task_recall'].map(name => this.renderDoubleCheck(name))
                    : this.lbl('interior.export.recall-done')}
                  <p></p>
                  {[
                    'kentekencard_aangevraagd',
                    // ...(this.vehicle.outgoing_company_country === "Germany" && this.vehicle.new_from_factory === null ? ['export_zulassung_aanvragen'] : []),
                    'export_betaalstatus_gecontroleerd',
                    'export_bpm_afgedragen',
                    // 'export_taak_aanmaken_demonteren',
                    'export_is_exported',
                  ].map(name => this.renderDoubleCheck(name))}
                </Cell>
              </Row>
            </VBox>,
          )}
        </VBox>

        <ModalControls>
          <PerformActionButton action={this.props.action} target={this.vehicle} onChange={this.reset.bind(this)} />
          <Button onClick={this.reset.bind(this)}>{this.lbl('cancel')}</Button>
        </ModalControls>
      </>
    );
  }

  render() {
    const vehicle = this.vehicle;

    if (!vehicle || !this.props.allOptions) return <Loader small />;

    return (
      <ActionCell>
        <Container>
          <VehicleHeader vehicle={vehicle} />
          <VehicleStatusLabel color={vehicle?.outgoing_invoice_payment_status ? '#15AC79' : 'red'}>
            {vehicle?.outgoing_invoice_payment_status ? 'betaald' : 'niet betaald'}
          </VehicleStatusLabel>
          <div className="small_letters">
            {vehicle?.task_apk === '1' || vehicle?.task_recall === '1' ? 'wacht op apk of terugroepactie' : null}
          </div>
          <CellButtons>
            <Label count={vehicle?.borgfactuur_counter} ranges={ranges}>
              {vehicle?.borgfactuur_counter || '0'}
            </Label>
            {this.props.cell.busy ? (
              <Loader small />
            ) : (
              <>
                <CellButton
                  onClick={this.setStateFn({ approve: !this.state.approve, regplate_code: vehicle.regplate_code || '' })}
                >
                  <View />
                </CellButton>
              </>
            )}
          </CellButtons>
          {this.renderApprove()}
        </Container>
      </ActionCell>
    );
  }

  onCommentChange = e => {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  };

  renderAttention() {
    const v = this.props.vehicle;

    if (!v) return null;

    let rows = [];

    for (let i = 0; i < 100; i++) {
      let photos = v.documents?.filter(d => {
        return d.type?.indexOf(`photo_interior_attention_${i}`) === 0;
      });

      if (!photos.length) continue;
      rows[i] = {
        index: i,
        photos,
      };
    }

    return (
      <VBox key="attentions">
        {rows.map(row => (
          <VBox>
            <HBox flexWrap left key={`attention-row-${row.index}`}>
              {row.photos.map(d => this.renderAttentionPhoto(d))}
              {row.photos.length < 4 && (
                <div className="thumb attention-img">
                  <VBox className="add" center vCenter onClick={() => this.addAttentionImage(row.index)}>
                    <Plus />
                  </VBox>
                </div>
              )}
            </HBox>
            <HBox></HBox>
          </VBox>
        ))}
        <Button onClick={() => this.addAttentionImage(rows[rows.length - 1]?.index + 1 || 0, true)}>
          <Plus />
          {this.lbl('add')}
        </Button>
      </VBox>
    );
    return null;
  }
}

IDW_export_overviewComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    allOptions: selectAllOptions(),
    vehicle: selectVehicle(ownProps.cell.vehicle.id),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    confirm(vehicle_id, regplate_code) {
      dispatch(performAction(ownProps.action.id, vehicle_id, { regplate_code }));
    },
    toggleOption(optionId, state, callback) {
      let fn = state ? addVehicleOption : removeVehicleOption;
      dispatch(fn(ownProps.cell.vehicle.id, optionId, callback));
    },
    setProperty(name, value) {
      dispatch(setVehicleProperty(ownProps.cell.vehicle.id, name, value));
    },
    imageUpload(documentDto, work, callback) {
      dispatch(addDocument(ownProps.cell.vehicle.id, 'vehicle', documentDto, callback, work));
    },
    deleteDocument(id, callback) {
      dispatch(deleteDocument(ownProps.cell.vehicle.id, 'vehicle', id, callback));
    },
    deleteProperty(name) {
      dispatch(deleteVehicleProperty(ownProps.cell.vehicle.id, name));
    },
    print() {
      dispatch(setVehicleProperty(ownProps.cell.vehicle.id, 'label_printer_queue', '1'));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const IDW_export_overview = compose(withConnect, withRouter)(IDW_export_overviewComp);
